import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, Star, TestTube } from "lucide-react";
import MobileNav from "./MobileNav";
import { useAuth } from "@/context/AuthContext";
import { useToast } from "@/hooks/use-toast";
import { useSiteSettings } from "@/hooks/use-site-settings";
import { ThemeToggle } from "./ThemeToggle";
const PublicHeader: React.FC = () => {
  const navigate = useNavigate();
  const {
    loginAsTestUser,
    isAuthenticated
  } = useAuth();
  const {
    toast
  } = useToast();
  const {
    featuresTestEnabled
  } = useSiteSettings();
  const handleTestLogin = async () => {
    // Check if user is already logged in
    if (isAuthenticated) {
      toast({
        title: "Already Logged In",
        description: "You are currently logged in. Please log out first to access the Features Test.",
        variant: "default"
      });
      return;
    }

    // Proceed with test login if not authenticated
    try {
      toast({
        title: "Setting up test account...",
        description: "Please wait while we prepare your demo experience."
      });
      const result = await loginAsTestUser();
      if (result.error) {
        toast({
          title: "Test Account Error",
          description: result.error,
          variant: "destructive"
        });
      } else {
        toast({
          title: "Welcome to the demo!",
          description: "Redirecting to the admin panel..."
        });
        navigate('/admin');
      }
    } catch (error: any) {
      toast({
        title: "Failed to access test account",
        description: error.message || 'Unknown error occurred',
        variant: "destructive"
      });
    }
  };
  return <header className="border-b bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/60 shadow-sm">
      <div className="container flex h-16 items-center px-2 sm:px-4">
        <div className="flex items-center gap-2 sm:gap-4">
          <Button variant="ghost" size="sm" onClick={() => navigate("/")} className="hover:bg-primary/10 hover:text-primary p-2 sm:px-3 hidden md:flex">
            <Home className="h-4 w-4 sm:mr-2" />
            <span className="hidden sm:inline">Home</span>
          </Button>
          
          <Button variant="ghost" size="sm" onClick={() => navigate("/features")} className="hover:bg-primary/10 hover:text-primary p-2 sm:px-3 hidden md:flex">
            <Star className="h-4 w-4 sm:mr-2" />
            <span className="hidden sm:inline">Features</span>
          </Button>

          <Button variant="ghost" size="sm" onClick={() => navigate("/collectors")} className="hover:bg-primary/10 hover:text-primary p-2 sm:px-3 hidden md:flex">
            <span className="hidden sm:inline">For Collectors</span>
          </Button>

          <Button variant="ghost" size="sm" onClick={() => navigate("/help")} className="hover:bg-primary/10 hover:text-primary p-2 sm:px-3 hidden md:flex">
            <span className="hidden sm:inline">Help Center</span>
          </Button>
          
          {/* Mobile home button - smaller */}
          <Button variant="ghost" size="sm" onClick={() => navigate("/")} className="hover:bg-primary/10 hover:text-primary p-1.5 md:hidden">
            <Home className="h-4 w-4" />
          </Button>
        </div>
        
        <div className="ml-auto flex items-center space-x-2 sm:space-x-3">
          <ThemeToggle />
          
          {featuresTestEnabled && <Button variant="outline" size="sm" onClick={handleTestLogin} className="hidden md:flex items-center gap-2 hover:bg-primary/10 hover:text-primary text-xs sm:text-sm">
              <TestTube className="h-3 w-3 sm:h-4 sm:w-4" />
              Features Test
            </Button>}
          
          
          <h1 className="text-xs sm:text-sm md:text-lg font-semibold bg-gradient-hero bg-clip-text text-transparent">
            ZooCertica
          </h1>
          
          {/* Mobile Navigation */}
          <MobileNav />
        </div>
      </div>
    </header>;
};
export default PublicHeader;